import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { User } from "@supabase/supabase-js";
import { GenerationHistory } from "@/components/features/artwork/GenerationHistory";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

const Generations = () => {
  const [user, setUser] = useState<User | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    // Check authentication
    const checkAuth = async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        navigate("/auth");
        return;
      }
      setUser(session.user);
    };

    checkAuth();

    // Listen for auth changes
    const { data: { subscription } } = supabase.auth.onAuthStateChange(
      (event, session) => {
        if (!session) {
          navigate("/auth");
        } else {
          setUser(session.user);
        }
      }
    );

    return () => subscription.unsubscribe();
  }, [navigate]);

  if (!user) {
    return (
      <div className="min-h-screen pt-20 pb-12 gradient-hero">
        <div className="container mx-auto px-6">
          <div className="text-center">
            <h1 className="text-4xl font-bold mb-4">Connexion requise</h1>
            <p className="text-foreground/80 mb-8">Vous devez être connecté pour voir vos générations</p>
            <Button variant="outline" onClick={() => navigate("/auth")}>
              Se connecter
            </Button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen pt-20 pb-12 bg-background">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Mes <span className="text-premium">Générations</span>
            </h1>
            <p className="text-xl text-foreground/80 max-w-2xl">
              Retrouvez toutes vos créations d'art et gérez vos commandes
            </p>
          </div>
          <Button onClick={() => navigate("/create")} className="hidden sm:flex">
            <Plus className="w-4 h-4 mr-2" />
            Nouvelle création
          </Button>
        </div>

        {/* Mobile Create Button */}
        <div className="sm:hidden mb-6">
          <Button onClick={() => navigate("/create")} className="w-full">
            <Plus className="w-4 h-4 mr-2" />
            Nouvelle création
          </Button>
        </div>

        {/* History Component */}
        <GenerationHistory />
      </div>
    </div>
  );
};

export default Generations;